import type React from 'react';

import * as styles from './styles';
import moment from 'moment';

import type { DateRange } from '@cobliteam/common-types';

import { type ChecklistsNames, isWebDataSuccess, type WebData } from '@cobliteam/api-lib';

import { Analytics } from '@cobliteam/analytics';

import { type CheckboxOption, DefaultInput, DropdownComponent, FilterMultipleDropdown, PeriodSelection, PeriodSelectionOption } from '@cobliteam/base-components';

import { SearchRounded } from '@mui/icons-material';

export interface ChecklistReceivedTableFilterProps {
  period: DateRange;
  checklistsNamesWebData: WebData<ChecklistsNames>;
  chipFilter: CheckboxOption[];
  className?: string;
  onInputFilterChange: (newInput: string) => void;
  setPeriod: (newPeriod: DateRange) => void;
  setChipFilter: (newChipFilter: CheckboxOption[]) => void;
}

export const ChecklistReceivedTableFilter: React.FC<ChecklistReceivedTableFilterProps> = ({
  period,
  chipFilter,
  className,
  setPeriod,
  setChipFilter,
  onInputFilterChange,
  checklistsNamesWebData,
}) => {
  const getDropdownOptions = (names: string[]): CheckboxOption[] => {
    const uniqueChecklists = names.reduce((acc: CheckboxOption[], name: string) => (acc.findIndex((r) => r.key === name) === -1 ? [...acc, { key: name, label: name }] : acc), []);

    return uniqueChecklists;
  };

  const handleOnFilterButtonChange = (selectedOptions: CheckboxOption[]) => {
    setChipFilter(selectedOptions);
  };
  const handleOnFilterButtonClearChange = () => {
    setChipFilter([]);
  };
  const handleOnInputFilterChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onInputFilterChange(event.target.value);
  };

  const handlePeriodChange = (newPeriod: DateRange) => {
    const daysRange = moment(newPeriod.end).diff(moment(newPeriod.start), 'days');
    Analytics.track('Checklists Period Selection Changed', {
      range: daysRange,
    });
    setPeriod(newPeriod);
  };

  const selectedOptionKeys = new Set(chipFilter.map((filter) => filter.key));

  return (
    <div className={`${styles.checklistFilters} ${className || ''}`}>
      <PeriodSelection period={period} initialDateOption={PeriodSelectionOption.PERIOD} onPeriodChange={handlePeriodChange} />

      <div className={styles.searchBoxFilters}>
        <DefaultInput
          placeholder='Pesquise por checklist, veículo ou motorista'
          className={styles.searchBox}
          onChange={handleOnInputFilterChange}
          startAdornment={<SearchRounded />}
        />
        <div className={styles.filterButton}>
          <FilterMultipleDropdown
            overlayClassName={styles.overlay}
            options={isWebDataSuccess(checklistsNamesWebData) ? getDropdownOptions(checklistsNamesWebData.data.names) : []}
            selectedOptionKeys={selectedOptionKeys}
            onApply={handleOnFilterButtonChange}
            onClear={handleOnFilterButtonClearChange}
            buttonTitle='Filtrar'
            renderComponent={DropdownComponent.CHIP}
            popperPlacementType='bottom-end'
            withActionButtons
          />
        </div>
      </div>
    </div>
  );
};

export default ChecklistReceivedTableFilter;
